//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum CreatorsCampaignsUnifiedMetricsStatsCreatorIdPrefix {
  Instagram = 'ig',
  TikTok = 'tt',
}

// The earliest date we can provide unified metrics stats for campaigns
export const CAMPAIGNS_UNIFIED_METRICS_STATS_EARLIEST_DATE = new Date(
  '2024-09-01',
);
